import React from "react";
import { Checkbox } from "antd";

export interface DaysOfWeekSelectorProps {
    disabled: boolean,
    key: string,
    value?:string[],
    onChange?: (selecteddays: string[]) => void;
};

const daysOfWeek = [
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sun",
];

const DaysOfWeekSelector: React.FC<DaysOfWeekSelectorProps> = ({ value = [],  onChange, disabled}) => {
    let selectedDays = value;
    let setSelectedDays = onChange;

    const handleCheckboxChange = (day: string) => {
            if(disabled)
                return;

            const newSelectedValue = selectedDays.includes(day)
            ? selectedDays.filter((d: string) => d !== day)
                    : [...selectedDays, day];
            setSelectedDays?.(newSelectedValue);
        };

    return (
            <div style={{display:'flex', flexDirection:'row', width:'60%'}}>
                {
                    daysOfWeek.map((day: string) => (
                        <div key={day} style={{display:'flex', flexDirection:'column', width:'100%', alignItems:'center'}}>
                            <span>{day}</span>
                            <Checkbox checked={selectedDays.includes(day)} onChange={() => handleCheckboxChange(day)} disabled={disabled}/>
                        </div>
                    ))
                }
            </div>
    );
};

export default DaysOfWeekSelector;
